import { api_request } from '../axios_client';
import { handleError } from '../common';
import * as Constants from '../constants';

const isMDM = true;
const entityBrandEntityGet = async (brand_name, entity_type, options) => {
  const resourcePath = `${Constants.PATH.MDM.ENTITY.brandEntity}`;

  try {
    const res = await api_request({
      methodType: 'get',
      resourcePath,
      params: { brand_name, entity_type },
      options,
      isMDM
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const entityIdGet = async (id, options) => {
  const resourcePath = `${Constants.PATH.MDM.ENTITY.entity}/${id}`;

  try {
    if (id) {
      const res = await api_request({
        methodType: 'get',
        resourcePath,
        options,
        isMDM
      });
      return res;
    }
  } catch (err) {
    handleError(err);
  }
};

const entityGet = async (params, options) => {
  const resourcePath = `${Constants.PATH.MDM.ENTITY.entity}`;

  try {
    const res = await api_request({
      methodType: 'get',
      resourcePath,
      params,
      options,
      isMDM
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const exportOnlineEntityGet = async (params, options) => {
  const resourcePath = `${Constants.PATH.MDM.ENTITY.exportOrderEntity}`;

  try {
    const res = await api_request({
      methodType: 'get',
      resourcePath,
      params,
      options,
      isMDM
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const markUpGet = async (params, options) => {
  const resourcePath = `${Constants.PATH.MDM.ENTITY.markUp}`;

  try {
    const res = await api_request({
      methodType: 'get',
      resourcePath,
      params,
      options,
      isMDM
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const portGet = async (params, options) => {
  const resourcePath = `${Constants.PATH.MDM.ENTITY.port}`;

  try {
    const res = await api_request({
      methodType: 'get',
      resourcePath,
      params,
      options,
      isMDM
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

export { entityBrandEntityGet, entityGet, entityIdGet, exportOnlineEntityGet, markUpGet, portGet };
